/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Order_Status_Vtp_ReturningInputs */

const vi_order_status_vtp_returning = /** @type {(inputs: Order_Status_Vtp_ReturningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`VTP đang hoàn về`)
};

/**

* @param {Order_Status_Vtp_ReturningInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const order_status_vtp_returning = /** @type {((inputs?: Order_Status_Vtp_ReturningInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Order_Status_Vtp_ReturningInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_order_status_vtp_returning(inputs)
});